const tokenPrice= {
  state: {
    eth_on_usd: "",
    axis_on_usd: "",
    usdt_on_usd: "",
  },
  mutations: {
    setTokenPriceKey(state, obj) {
      for (let key in obj) {
        state[key] = obj[key];
      }
    },
  },
}

export default tokenPrice